'use client';

import { SocialLinks } from './social-links';

export const Footer: React.FC = () => {
  return (
    <div className='flex flex-col gap-10 pb-10'>
      <div className='flex flex-col justify-center gap-2 text-center text-white'>
        <div className='flex items-center justify-center gap-4'>
          <SocialLinks />
        </div>

        <div className='flex flex-col items-center justify-center'>
          <div className='flex items-center justify-center gap-1 text-sm font-semibold'>
            <a
              href='https://www.doodles.app/terms'
              target='_blank'
              rel='noopener'
            >
              Terms of Use
            </a>
            <span>|</span>
            <a
              href='https://www.doodles.app/privacy-policy'
              target='_blank'
              rel='noopener'
            >
              Privacy Policy
            </a>
          </div>

          <div className='flex items-center justify-center gap-1 text-sm'>
            <p>ⓒ</p>
            <p className='font-kumbh'>Doodles, LLC. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
